import { $applyNodeReplacement } from "lexical";
import { VideoNode } from "./VideoNode.js";
function $createVideoNode(src, description) {
    return $applyNodeReplacement(new VideoNode(src, description));
}
export { $createVideoNode };
